import { render } from "./pay.vue?vue&type=template&id=40ba5e43"
import script from "./pay.vue?vue&type=script&lang=js"
export * from "./pay.vue?vue&type=script&lang=js"

import "./pay.vue?vue&type=style&index=0&id=40ba5e43&lang=scss"

import exportComponent from "/Users/opm/opm-vue-pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__